// utils/storage.js

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const USER_KEY = "user";
const ORGANIZATION_SETTINGS_KEY = "organizationSettings";

// 🔹 Save access token
export const setAccessToken = (token) => {
  console.log("Set access token was called");

  if (token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  }
};

// 🔹 Get access token
export const getAccessToken = () => {
  console.log("Get access token was called");

  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

// 🔹 Remove access token
export const removeAccessToken = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};

// 🔹 Save refresh token
export const setRefreshToken = (token) => {
  if (token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }
};

// 🔹 Get refresh token
export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

// 🔹 Remove refresh token
export const removeRefreshToken = () => {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

// 🔹 Save user object (stringify)
export const setUser = (user) => {
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
};

// 🔹 Save user object (stringify)
export const setOrgaizationSettings = (organizationSettings) => {
  if (organizationSettings) {
    localStorage.setItem(
      ORGANIZATION_SETTINGS_KEY,
      JSON.stringify(organizationSettings)
    );
  }else{
    localStorage.setItem(ORGANIZATION_SETTINGS_KEY, "");
  }
};

// 🔹 Get user object (parse)
export const getOrganizationSettings = () => {
  const organizationSettings = localStorage.getItem(ORGANIZATION_SETTINGS_KEY);
  return organizationSettings ? JSON.parse(organizationSettings) : null;
};

// 🔹 Get user object (parse)
export const getUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

// 🔹 Remove user
export const removeUser = () => {
  localStorage.removeItem(USER_KEY);
};

// 🔹 Clear all auth storage
export const clearAuthStorage = () => {
  removeAccessToken();
  removeRefreshToken();
  removeUser();
};

// 🔹 Clear all auth storage
export const clearAllStorage = () => {
  removeAccessToken();
  removeRefreshToken();
  removeUser();
  localStorage.removeItem(ORGANIZATION_SETTINGS_KEY);
};
